import ReactDOM from 'react-dom'
import { Router } from 'react-router'
import '../css/app' // all-in-one for now
import MainLegacy from '../containers/main'
import MainOneapp from '../containers/mainOneappNew'
import { inited, history, getFrameworkVar } from '../framework/states'
import { DEFAULT_ROOT_ELEMENT_ID } from '../framework/constants'
import type { SparkySettings } from '../framework/microAppTypes'

const render = (settings: SparkySettings) => {
  Object.defineProperties(inited, { settings: { value: settings } })
  const Main = getFrameworkVar('use_new_left_nav') ? MainOneapp : MainLegacy
  ReactDOM.render(
    <Router history={history}>
      <Main settings={settings} />
    </Router>,
    document.getElementById(DEFAULT_ROOT_ELEMENT_ID)
  )
  inited.resolve(settings)
}

export default render
